import React, { Fragment, useState } from 'react';
import PropTypes from 'prop-types';
import {
  RESTORE_ENTITY_MUTATION,
  RESTORE_USER_ENTITY_MUTATION,
  RESTORE_REPORT_ENTITY_MUTATION,
  RESTORE_NOTIFICATION_ENTITY_MUTATION,
} from 'src/graphql/restoreEntity/mutation';
import { useMutation } from 'src/graphql';
import { notification } from 'src/components/Notification';
import { Trans } from 'react-i18next';
import { useActivityCreate } from 'src/hooks/activity';
import s from './RestoreButton.styles';

const RestoreButton = ({ id, resourceName }) => {
  const [restoreMutation] = useMutation(RESTORE_ENTITY_MUTATION);
  const [restoreUserEntityMutation] = useMutation(RESTORE_USER_ENTITY_MUTATION);
  const [restoreReportEntityMutation] = useMutation(RESTORE_REPORT_ENTITY_MUTATION);
  const [restoreNotificationEntityMutation] = useMutation(RESTORE_NOTIFICATION_ENTITY_MUTATION);

  const [disableRestore, setDisableRestore] = useState(false);

  const createActivity = useActivityCreate();
  const forceRefetch = () => {
    window.location.reload();
  };

  const onRestore = async () => {
    let mutation = restoreMutation;
    
    setDisableRestore(true);

    if (['Role', 'User', 'FilteringRuleGroup'].includes(resourceName)) {
      mutation = restoreUserEntityMutation;
    }
    if (['ReportTemplate'].includes(resourceName)) {
      mutation = restoreReportEntityMutation;
    }
    if (['EmailTemplate', 'Notification'].includes(resourceName)) {
      mutation = restoreNotificationEntityMutation;
    }
    try {
      const response = await mutation({
        variables: {
          resourceName,
          id: +id,
        },
      });
      if ((response.data.restoreEntity || response.data.restoreUserEntity || response.data.restoreReportEntity || response.data.restoreNotificationEntity).successful) {
        if (['Role', 'User', 'FilteringRuleGroup', 'ReportTemplate', 'EmailTemplate', 'Notification'].includes(resourceName)) {
          createActivity({
            entityType: resourceName,
            entityId: +id,
            action: 'restore',
          });
        }
        forceRefetch();
      } else {
        notification.error('Unknown error restoring item');
      }
    } catch (e) {
      const errors = [];
      Object.keys(e.graphQLErrors[0]?.extensions?.errors || {}).forEach(key => {
        const value = e.graphQLErrors[0]?.extensions?.errors[key];
        errors.push(`${key} ${value.join(', ')}`);
      });
      notification.error(<span>{e.toString()}<br/><br/>{errors.join(', ')}</span>);
    }
    setDisableRestore(false);
  };

  return (
    <Fragment>
      <s.RestoreButton disabled={disableRestore} link onClick={onRestore} type="button">
        <Trans>RESTORE</Trans>
      </s.RestoreButton>
    </Fragment>
  );
};

RestoreButton.propTypes = {
  id: PropTypes.number.isRequired,
  resourceName: PropTypes.string.isRequired,
};

RestoreButton.defaultProps = {};

export default RestoreButton;
